import React from "react";
import Markdown from "react-markdown";

import Image from "next/image";

export default function DataCollection({
  data_collection_desc,
  data_collection_types,
  period_chart,
}: {
  data_collection_desc?: string;
  data_collection_types?: string;
  period_chart?: string;
}) {
  let parsedDataCollectionTypes: Record<string, string> | undefined;

  try {
    if (data_collection_types) {
      parsedDataCollectionTypes = JSON.parse(data_collection_types);
    }
  } catch (error) {
    console.error("Failed to parse data_collection_types:", error);
  }

  return (
    <div className="tab-pane fade show active">
      {data_collection_desc && (
        <div className="g2-text-grey">
          <Markdown>{data_collection_desc}</Markdown>
        </div>
      )}
      {period_chart && (
        <div className="text-center my-4">
          <Image src={period_chart} className="img-fluid" alt="Period Chart" width={1000} height={100} />
        </div>
      )}
      {parsedDataCollectionTypes && (
        <table className="table table-hover table-striped" width="100%">
          <tbody>
            {Object.entries(parsedDataCollectionTypes).map(([field, value], index) => (
              <tr key={index}>
                <td width="25%" className="fw-bold text-end">
                  {field}
                </td>
                <td width="75%">{value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
